import React from 'react';
import Modal from 'react-modal';
import { T, useTranslate } from 'shared/helper/translate';
var RubriqTransitionModal = function RubriqTransitionModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  if (new Date() > new Date('2026-09-30')) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, open && /*#__PURE__*/React.createElement(Modal, {
    appElement: window.document.querySelector('#researcher-app'),
    className: "react-modal",
    isOpen: true,
    overlayClassName: "react-modal-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: function onClick() {
      return onClose();
    },
    "aria-label": t('Close')
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/React.createElement("h1", {
    className: "react-modal-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: "introducing curie"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
    source: "aje digital editing and translation is now curie"
  })), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
    source: "curie.transition-general-description"
  })), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
    source: "curie.transition-translation-description"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-footer"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('got-it'),
    type: "button",
    className: "btn btn-primary btn-squared",
    onClick: function onClick() {
      return onClose();
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "got-it"
  })))));
};
export default RubriqTransitionModal;